/**
 * A payback's match chip (TMMAPP-0121 item 3; TMMAPP-0122 item 12): the review queue's pair card and
 * the drawer's reimbursement section show the same one. A link the person made is neutral, as it's
 * no match grade.
 */
import { Pill } from '@/components/Pill';
import { gradeChipColor, type MatchFacts } from './reimbursementMatch';

export function MatchPill({ match, label }: { match: MatchFacts; label: string }) {
  const manual = match.reasonCode === 'MANUAL';
  return (
    <Pill
      tone={manual ? 'neutral' : gradeChipColor(match.grade)}
      data-paint={`match-${manual ? 'MANUAL' : match.grade}`}
    >
      {label}
    </Pill>
  );
}
